import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { getRealEstatePropStats } from 'redux/realEstateSlice';
import ModalButtonsContainer from 'sites/common/ModalButtonsContainer';
import ButtonAccept from 'utils/buttons/ButtonAccept';
import ButtonClose from 'utils/buttons/ButtonClose';

const ActiveModal = ({ property, setShow, handleStatus }) => {
  const handleClose = () => setShow(false);

  const { realEstate } = useSelector(state => state.realEstate);
  const dispatch = useDispatch();

  const handleActive = async prop => {
    await handleStatus(prop);
    dispatch(getRealEstatePropStats(realEstate.id));
    handleClose();
  };

  return (
    <Modal
      keyboard={true}
      show={true}
      onHide={handleClose}
      backdrop="static"
      centered
    >
      <Modal.Header closeButton>
        <FontAwesomeIcon
          icon="fa-power-off"
          size="1x"
          title="Activar"
          style={{ marginRight: 8, color: '#00d97e' }}
        />

        <Modal.Title>Activar propiedad</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="mb-4">
          La propiedad de dirección{' '}
          <b>
            {property.location.street} {property.location.number}
          </b>{' '}
          se activará y los clientes podrán verla y consultar por ella.
          <br />
          <br />
          ¿Está seguro de confirmar esta acción?
        </div>
        <ModalButtonsContainer>
          <ButtonClose text="Cancelar" funcion={handleClose} />
          <ButtonAccept
            text="Activar"
            funcion={handleActive}
            data={{ id: property._id, status: 'published' }}
          />
        </ModalButtonsContainer>
      </Modal.Body>
    </Modal>
  );
};

ActiveModal.propTypes = {
  property: PropTypes.object.isRequired,
  setShow: PropTypes.func.isRequired,
  handleStatus: PropTypes.func.isRequired
};

export default ActiveModal;
